import React from "react"
import { View } from "react-native"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H5, Small } from "@/components/standard/BFText"
import { Card, CardContent } from "@/components/reusables/ui/card"

interface ProcessorInfo {
  name: string
  title?: string
  phone?: string
  email?: string
  avatar?: string
}

interface ProcessorCardProps {
  processor?: ProcessorInfo
  onPhonePress?: () => void
  onMessagePress?: () => void
  onSchedulePress?: () => void
  onEmailPress?: () => void
}

// Default processor info if none provided
const defaultProcessor: ProcessorInfo = {
  name: "Your Processor",
  title: "Loan Processor",
  phone: "(555) 123-4567",
  email: "processor@backflip.com",
}

export const ProcessorCard: React.FC<ProcessorCardProps> = ({
  processor = defaultProcessor,
  onPhonePress,
  onMessagePress,
  onSchedulePress,
  onEmailPress,
}) => {
  return (
    <Card className="mt-3">
      <CardContent className="p-4">
        <Horizontal className="items-center gap-4">
          {/* Avatar placeholder */}
          <View className="size-12 bg-muted rounded-full items-center justify-center">
            <Small color="hint">
              {processor.name
                .split(" ")
                .map((n) => n[0])
                .join("")
                .toUpperCase()}
            </Small>
          </View>

          {/* Processor info */}
          <Vertical className="flex-1">
            <H5 color="default">{processor.name}</H5>
            {processor.title && <Small color="hint">{processor.title}</Small>}
          </Vertical>
        </Horizontal>
      </CardContent>
    </Card>
  )
}
